import React from 'react';
import { motion } from 'framer-motion';
import { useMarketData } from '../context/MarketDataContext';

const MarketTicker = () => {
  const { marketData } = useMarketData();

  const tickerData = marketData && Object.keys(marketData).length > 0 
    ? Object.entries(marketData).map(([symbol, data]) => ({
        symbol,
        price: data.price || 0,
        change: data.changePercent || 0,
        isPositive: (data.changePercent || 0) >= 0
      }))
    : [];

  return (
    <div className="bg-black bg-opacity-80 border-b border-gray-700 overflow-hidden">
      <div className="flex items-center py-2">
        <div className="flex-shrink-0 px-4">
          <span className="text-white font-bold text-sm">📊 LIVE MARKET</span>
        </div>
        
        <div className="flex-1 overflow-hidden">
          {tickerData.length > 0 ? (
            <motion.div
              className="flex space-x-8 ticker"
              animate={{ x: [0, -100 * tickerData.length] }}
              transition={{
                duration: 30,
                repeat: Infinity,
                ease: "linear"
              }}
            >
              {[...tickerData, ...tickerData].map((item, index) => (
                <div key={`${item.symbol}-${index}`} className="flex items-center space-x-2 whitespace-nowrap">
                  <span className="text-white font-bold">{item.symbol}</span>
                  <span className="text-gray-300">${item.price.toFixed(2)}</span>
                  <span className={`text-sm ${item.isPositive ? 'text-green-400' : 'text-red-400'}`}>
                    {item.isPositive ? '+' : ''}{item.change.toFixed(2)}%
                  </span>
                </div>
              ))}
            </motion.div>
          ) : (
            <div className="flex items-center justify-center py-2">
              <span className="text-gray-400 text-sm">Loading market data...</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default MarketTicker;